import React, { useState, useCallback, useRef, useEffect } from "react";
import Sidebar from "./Sidemenu";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactFlow, { addEdge } from "react-flow-renderer";
import { useDrag, useDrop } from "react-dnd";
import { Button, Modal, Form, InputGroup, FormControl } from "react-bootstrap";
import {
  BsList,
  BsSearch,
  BsChatDots,
  BsBell,
  BsGear,
  BsPower,
} from "react-icons/bs";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { BiCalendar } from "react-icons/bi";
import { FaList, FaCog, FaFile, FaFileAlt, FaCube } from "react-icons/fa";

import axios from "axios";

const DraggableOption = ({ label, imageUrl }) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: "OPTION",
    item: { label, imageUrl },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div
      className={`col-6 d-flex align-items-center mb-3 ${
        isDragging ? "dragging" : ""
      }`}
    >
      <div
        ref={drag}
        className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center mr-3 mb-3"
        style={{
          width: "50px",
          height: "50px",
          backgroundColor: "#441AFF",
          borderRadius: "50%",
        }}
      >
        <div ref={preview}>
          <img
            src={imageUrl}
            alt={label}
            className="img-fluid"
            style={{ borderRadius: "50%", width: "30px", height: "30px" }}
          />
        </div>
      </div>
      <span style={{ fontSize: "16px" }}>{label}</span>
    </div>
  );
};

// Standalone JavaScript file (e.g., captureURL.js)

const LaunchCampaignBuilder = () => {
  const [elements, setElements] = useState([]);
  const [name, setName] = useState([]);
  const [field, setField] = useState("");
  const [Selectedvalue, setSelectedvalue] = useState("");
  const [dynamiccontentvalue, setdynamiccontentvalue] = useState("");
  const [activeButton, setActiveButton] = useState(null);
  const [savedDetails, setSavedDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deviceType, setDeviceType] = useState("");
  const [deviceBrand, setDeviceBrand] = useState("");

  const [amPm, setAmPm] = useState("AM");
  const [specifiedTime, setSpecifiedTime] = useState("");

  const [deviceOS, setDeviceOS] = useState("");

  const [dynamiccontent, setDynamiccontent] = useState([]);
  const [devicevisitType, setDevicevisitType] = useState("");
  const [devicevisitBrand, setDevicevisitBrand] = useState("");
  const [devicevisitOS, setDevicevisitOS] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [url, seturl] = useState("");
  const [ValidEmailAddressVisible, setValidEmailAddressVisible] =
    useState(false);
  const [deviceVisitModalVisible, setDeviceVisitModalVisible] = useState(false);
  const [executionType, setExecutionType] = useState("");
  const [specifiedDate, setSpecifiedDate] = useState("");
  const [selectedAsset, setSelectedAsset] = useState("");

  const navigate = useNavigate();
  const [modalName, setModalName] = useState([]);
  const [modalName2, setModalName2] = useState([]);
  const [modalName3, setModalName3] = useState([]);
  const [modalName4, setModalName4] = useState([]);
  const [modalName5, setModalName5] = useState([]);
  const [modalName6, setModalName6] = useState([]);
  const [modalName7, setModalName7] = useState([]);
  const [modalName8, setModalName8] = useState([]);
  const [modalName9, setModalName9] = useState([]);
  const [modalName10, setModalName10] = useState([]);
  const [modalName11, setModalName11] = useState([]);
  const [modalName12, setModalName12] = useState([]);
  const [modalName13, setModalName13] = useState([]);
  const [modalName14, setModalName14] = useState([]);
  const [modalName15, setModalName15] = useState([]);
  const [modalName16, setModalName16] = useState([]);
  const [contactName, setContactName] = useState("");
  const [deletecontact, setdeletecontact] = useState("");
  const [pointsAdjustmentname, setpointsAdjustmentname] = useState("");
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [emailContentType, setEmailContentType] = useState("");
  const [addContactDetails, setAddContactDetails] = useState("");
  const [removeContactDetails, setRemoveContactDetails] = useState("");
  const [pointsAdjustment, setPointsAdjustment] = useState("");
  const [delayTime, setDelayTime] = useState("");
  const [delayUnit, setDelayUnit] = useState("");

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [ContactFieldVisible, setContactFieldVisible] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [dynamicContentTitle, setDynamicContentTitle] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [FormFieldModalVisible, setFormFieldModalVisible] = useState(false);
  const [fieldValue, setFieldValue] = useState("");
  const [operator, setOperator] = useState("");
  const [formoperator, setformOperator] = useState("");

  const [formvalue, setformvalue] = useState(" ");
  const [contactformvalue, setcontactformvalue] = useState("");
  const [DataToSend, setDataToSend] = useState(null);
  const [usernames, setUsernames] = useState([]);
  const [selectedUsername, setSelectedUsername] = useState("");

  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [showDeleteContactModal, setShowDeleteContactModal] = useState(false);
  const [showAdjustContactPointsModal, setShowAdjustContactPointsModal] =
    useState(false);
  const [showAddDoNotContactModal, setShowAddDoNotContactModal] =
    useState(false);
  const [downloadAssetModalVisible, setDownloadAssetModalVisible] =
    useState(false);
  const [ContactDeviceVisible, setContactDeviceVisible] = useState(false);
  const [ContactSegmentModalVisible, setContactSegmentModalVisible] =
    useState(false);
  const [
    RequestDynamicContentModalVisible,
    setRequestDynamicContentModalVisible,
  ] = useState(false);
  const [submitFormModalVisible, setSubmitFormModalVisible] = useState(false);
  const [visitPageModalVisible, setVisitPageModalVisible] = useState(false);
  const [savedetails, setsavedetails] = useState("");

  const ContentArea = ({
    elements,
    setElements,
    setShowCampaignModal,
    setValidEmailAddressVisible,
    setShowAddDoNotContactModal,
    setContactDeviceVisible,
    setContactFieldVisible,
    setFormFieldModalVisible,
    setContactSegmentModalVisible,
    setShowDeleteContactModal,
    setShowAdjustContactPointsModal,
    setShowEmailModal,
    setDownloadAssetModalVisible,
    setDeviceVisitModalVisible,
    setRequestDynamicContentModalVisible,
    setSubmitFormModalVisible,
    setVisitPageModalVisible,
  }) => {
    const containerRef = useRef(null);

    const handleDrop = useCallback((item, monitor) => {
      const containerRect = containerRef.current.getBoundingClientRect();
      const offset = monitor.getClientOffset();

      if (offset && containerRect) {
        const x = offset.x - containerRect.left;
        const y = offset.y - containerRect.top;

        const newElement = {
          id: item.label,
          type: "default",
          position: { x, y },
          data: {
            label: item.label,
            imageUrl: item.imageUrl,
          },
        };

        setElements((prevElements) => {
          const updatedElements = [...prevElements, newElement];

          if (prevElements.length >= 1) {
            const sourceNode = prevElements[prevElements.length - 1].id;
            const targetNode = newElement.id;

            // Your dynamic condition for connecting nodes
            const shouldConnectNodes =
              prevElements[prevElements.length - 1].type === "someType";

            if (shouldConnectNodes) {
              updatedElements.push({
                id: `${sourceNode}-${targetNode}`,
                source: sourceNode,
                target: targetNode,
                animated: true,
              });
              console.log("Connecting nodes:", sourceNode, "->", targetNode);
            }
          }

          return updatedElements;
        });

        console.log("Dropped element:", {
          label: item.label,
          imageUrl: item.imageUrl,
          position: { x, y },
        });

        if (item.label === "Change Campaigns") {
          setShowCampaignModal(true);
        } else if (item.label === "Valid Email Address") {
          setValidEmailAddressVisible(true);
        } else if (item.label === "Delay") {
          setShowAddDoNotContactModal(true);
        } else if (item.label === "Contact Device") {
          setContactDeviceVisible(true);
        } else if (item.label === "Contact field value") {
          setContactFieldVisible(true);
        } else if (item.label === "Form field value") {
          setFormFieldModalVisible(true);
        } else if (item.label === "Contact segments") {
          setContactSegmentModalVisible(true);
        } else if (item.label === "Delete Contact") {
          setShowDeleteContactModal(true);
        } else if (item.label === "Adjust Contact Point") {
          setShowAdjustContactPointsModal(true);
        } else if (item.label === "Send Email") {
          setShowEmailModal(true);
        } else if (item.label === "Download Asset") {
          setDownloadAssetModalVisible(true);
        } else if (item.label === "Device Visit") {
          setDeviceVisitModalVisible(true);
        } else if (item.label === "Request Dynamic Content") {
          setRequestDynamicContentModalVisible(true);
        } else if (item.label === "Submit form") {
          setSubmitFormModalVisible(true);
        } else if (item.label === "Visit a page") {
          setVisitPageModalVisible(true);
        }
      }
    });

    const [{ isOver }, drop] = useDrop({
      accept: "OPTION",
      drop: handleDrop,
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    });

    const onConnect = useCallback(async (params) => {
      console.log(`Connecting nodes: ${params.source} -> ${params.target}`);

      setElements((els) => {
        const updatedElements = addEdge(params, els);

        // Extract only nodes from the updatedElements array
        const nodes = updatedElements.filter((el) => el.type === "default");

        // Create a string representation of connected nodes
        const connectionString = nodes.map((node) => node.id).join(" -> ");

        // Update data flow based on the connection
        const sourceNode = nodes.find((node) => node.id === params.source);
        const targetNode = nodes.find((node) => node.id === params.target);
        if (sourceNode.data && targetNode.data) {
          // Example: If sourceNode carries email address, update targetNode's data
          targetNode.data.contactFieldValue = sourceNode.data.emailAddress;
        }

        console.log("Updated Elements:", connectionString);

        // Define an object with all necessary data
        const dataToSend = {
          connectionString,
          contactName,
          executionType,
          specifiedDate,
          addContactDetails,
          removeContactDetails,
          pointsAdjustment,
          emailContentType,
          subject,
          message,
          delayTime,
          delayUnit,
          selectedAsset,
          specifiedDate,
          deviceType,
          deviceBrand,
          deviceOS,
          amPm,
          specifiedTime,
          selectedFile,

          deletecontact,
          dynamicContentTitle,
          campaignName,
          url,
          savedetails,
          Selectedvalue,
          fieldValue,
          formvalue,
          contactformvalue,
          operator,
          formoperator,
          field,
          pointsAdjustmentname,
          selectedUsername,
          devicevisitType,
          devicevisitBrand,
          devicevisitOS,
          dynamiccontentvalue,
        };

        console.log("Data to send:", dataToSend);
        setDataToSend(dataToSend);
        return updatedElements;
      });
    }, []);

    const handleCloseButtonClick = async () => {
      if (DataToSend) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/Campaigndetails`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(DataToSend),
            }
          );

          if (response.ok) {
            console.log("Data successfully sent to the server");
          } else {
            console.error("Failed to send data to the server");
          }
        } catch (error) {
          console.error("Error sending data to the server:", error);
        }
      } else {
        console.log("No data to send");
      }
    };

    return (
      <div
        ref={drop}
        className={`bg-white border border-dark p-3 mt-3 ${
          isOver ? "is-over" : ""
        }`}
        style={{ height: "60vh", position: "relative" }}
      >
        <div
          ref={containerRef}
          style={{ position: "relative", width: "100%", height: "100%" }}
        >
          <ReactFlow
            elements={elements}
            onElementsRemove={(elementsToRemove) =>
              setElements((els) =>
                els.filter(
                  (el) => !elementsToRemove.find((er) => er.id === el.id)
                )
              )
            }
            snapToGrid={true}
            snapGrid={[15, 15]}
            nodesDraggable={true}
            nodesConnectable={true}
            deleteKeyCode={46}
            onConnect={onConnect}
            onLoad={(reactFlowInstance) => {
              reactFlowInstance.fitView();
            }}
            elementsSelectable={false}
          ></ReactFlow>
        </div>
        <button
          className="btn btn-white ml-3 mr-3"
          style={{
            borderRadius: "5px",
            backgroundColor: "#FFFFFF",
            color: "black",
            border: "1px solid black",
            position: "absolute",
            top: "-150px",
            zIndex:'999'
          }}
          onClick={handleCloseButtonClick}
        >
          Test it out
        </button>
      </div>
    );
  };

  const handleLogout = () => {
    navigate("/login");
  };

  const contactFieldOptions = [
    "Address Line1",
    "Address Line2",
    "City",
    "Country",
    "First Name",
    "Last Name",
    "Mobile",
    "Phone",
    "State",
    "Location",
    "Points",
  ];

  const handleActivateClick = () => {};

  const handleCloseModal = async () => {
    setShowCampaignModal(false);
  };

  const handleDropdownChange = async (selectedOption) => {
    setSelectedSegment(selectedOption);
    console.log("Selected option name:", selectedOption);
  };

  const handleDropdown2Change = (selectedValue) => {
    // Here, you can update the state with the selected option
    setSelectedvalue(selectedValue);
  };

  const handleDropdown3Change = (selectedValue) => {
    // Here, you can update the state with the selected option
    setdynamiccontentvalue(selectedValue);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file ? file.name : null);
  };

  const handleSubjectChange = (value) => {
    setSubject(value);
  };

  const handleMessageChange = (value) => {
    setMessage(value);
  };

  const handleEmailContentTypeChange = (type) => {
    setEmailContentType(type);
  };

  const handleAddContactChange = (value) => {
    setAddContactDetails(value);
  };

  const handleRemoveContactChange = (value) => {
    setRemoveContactDetails(value);
  };

  const handleDelayTimeChange = (value) => {
    setDelayTime(value);
  };

  const handleDelayUnitChange = (value) => {
    setDelayUnit(value);
  };

  const handlePointsAdjustmentChange = (value) => {
    // Ensure the input is a valid number or an empty string
    if (/^[+-]?\d*\.?\d*$/.test(value)) {
      setPointsAdjustment(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/saveddetails`
        );
        const data = await response.json();
        setSavedDetails(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching saved details:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchDynamicContent = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/dynamiccontent`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch dynamic content");
        }
        const data = await response.json();
        // Assuming the data structure is an array of objects with an 'internalName' property
        const dynamicContentNames = data.map((item) => item.internalNames);
        setDynamiccontent(dynamicContentNames);
        console.log("Dynamic Content:", dynamicContentNames);
      } catch (error) {
        console.error("Error fetching dynamic content:", error);
      }
    };

    fetchDynamicContent();
  }, []);

  useEffect(() => {
    const fetchUsernames = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/formdetails`
        );
        if (!response.ok) {
          // If the response was not ok, throw an error
          throw new Error("Failed to fetch usernames");
        }
        const data = await response.json();
        // Assuming the data structure is an array of objects with a 'username' property
        const usernames = data.map((item) => item.username);
        setUsernames(usernames);
      } catch (error) {
        console.error("Error fetching usernames:", error);
      }
    };

    fetchUsernames();
  }, []);

  const handleExecutionTypeChange = (type) => {
    setExecutionType(type);
    setSpecifiedDate("");
  };

  const conditionOptions = [
    { label: "Valid Email Address", imageUrl: "images/lockk.png" },
    { label: "Contact Device", imageUrl: "images/lockk.png" },
    { label: "Contact field value", imageUrl: "images/lockk.png" },
    { label: "Contact segments", imageUrl: "images/lockk.png" },
    { label: "Form field value", imageUrl: "images/lockk.png" },
  ];

  const decisionOptions = [
    { label: "Download Asset", imageUrl: "images/lockk.png" },
    { label: "Device Visit", imageUrl: "images/lockk.png" },
    { label: "Request Dynamic Content", imageUrl: "images/lockk.png" },
    { label: "Submit form", imageUrl: "images/lockk.png" },
    { label: "Visit a page", imageUrl: "images/lockk.png" },
  ];

  const actionOptions = [
    { label: "Delete Contact", imageUrl: "images/lockk.png" },

    { label: "Adjust Contact Point", imageUrl: "images/lockk.png" },
    { label: "Delay", imageUrl: "images/lockk.png" },
    { label: "Send Email", imageUrl: "images/lockk.png" },
  ];
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex">
        <Sidebar />
        <div style={{ width: "100%", height: "100vh", overflowY: "auto" }}>
          <div
            className="bg-white border border-dark d-flex flex-column align-items-start"
            style={{ marginTop: "50px" }}
          >
            <div className="d-flex justify-content-between w-100">
              <p className="font-family-inter font-size-12 text-black">
                Email Campaign Customization Configuration
              </p>

              <div className="d-flex ">
                <button
                  className=" btn-white"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    color: "black",
                    border: "1px solid black",
                  }}
                >
                  Save as Draft
                </button>

                <button
                  className=" btn-white"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    color: "black",
                    border: "1px solid black",
                  }}
                >
                  Close
                </button>

                <button
                  className=" btn-white"
                  style={{
                    padding: "10px",
                    borderRadius: "5px",
                    backgroundColor: "#4318FF",
                    color: "black",
                  }}
                  onClick={handleActivateClick}
                >
                  Activate
                </button>
              </div>
            </div>

            <div className="container-fluid">
              <div className="d-flex">
                <div style={{width:'60%'}}>
                  <ContentArea
                    elements={elements}
                    setElements={setElements}
                    setShowCampaignModal={setShowCampaignModal}
                    setValidEmailAddressVisible={setValidEmailAddressVisible}
                    showAddDoNotContactModal={showAddDoNotContactModal}
                    setShowAddDoNotContactModal={setShowAddDoNotContactModal}
                    ContactDeviceVisible={ContactDeviceVisible}
                    setContactDeviceVisible={setContactDeviceVisible}
                    ContactFieldVisible={ContactFieldVisible}
                    setContactFieldVisible={setContactFieldVisible}
                    FormFieldModalVisible={FormFieldModalVisible}
                    setFormFieldModalVisible={setFormFieldModalVisible}
                    ContactSegmentModalVisible={ContactSegmentModalVisible}
                    setContactSegmentModalVisible={
                      setContactSegmentModalVisible
                    }
                    showDeleteContactModal={showDeleteContactModal}
                    setShowDeleteContactModal={setShowDeleteContactModal}
                    showAdjustContactPointsModal={showAdjustContactPointsModal}
                    setShowAdjustContactPointsModal={
                      setShowAdjustContactPointsModal
                    }
                    showEmailModal={showEmailModal}
                    setShowEmailModal={setShowEmailModal}
                    downloadAssetModalVisible={downloadAssetModalVisible}
                    setDownloadAssetModalVisible={setDownloadAssetModalVisible}
                    deviceVisitModalVisible={deviceVisitModalVisible}
                    setDeviceVisitModalVisible={setDeviceVisitModalVisible}
                    RequestDynamicContentModalVisible={
                      RequestDynamicContentModalVisible
                    }
                    setRequestDynamicContentModalVisible={
                      setRequestDynamicContentModalVisible
                    }
                    submitFormModalVisible={submitFormModalVisible}
                    setSubmitFormModalVisible={setSubmitFormModalVisible}
                    visitPageModalVisible={visitPageModalVisible}
                    setVisitPageModalVisible={setVisitPageModalVisible}
                  />
                </div>
                <div style={{width:'40%'}}>
                  <div
                    className="bg-white border border-dark p-3 mt-3"
                    style={{ height: "60vh", backgroundColor: "#F4F7FE" }}
                  >
                    <div
                      className="d-flex"
                      style={{ marginTop: "-60px", height: "20vh" }}
                    >
                      <div className="col-4">
                        <button
                          className={`btn btn-block ml-2 ${
                            activeButton === "Condition"
                              ? "btn-primary"
                              : "btn-light"
                          }`}
                          style={{
                            backgroundColor:
                              activeButton === "Condition" ? "#441AFF" : "",
                          }}
                          onClick={() => handleButtonClick("Condition")}
                        >
                          Condition
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          className={`btn btn-block ml-2 ${
                            activeButton === "Decision"
                              ? "btn-primary"
                              : "btn-light"
                          }`}
                          style={{
                            backgroundColor:
                              activeButton === "Decision" ? "#441AFF" : "",
                          }}
                          onClick={() => handleButtonClick("Decision")}
                        >
                          Decision
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          className={`btn btn-block ml-2 ${
                            activeButton === "Action"
                              ? "btn-primary"
                              : "btn-light"
                          }`}
                          style={{
                            backgroundColor:
                              activeButton === "Action" ? "#441AFF" : "",
                          }}
                          onClick={() => handleButtonClick("Action")}
                        >
                          Action
                        </button>
                      </div>
                    </div>

                    <DndProvider backend={HTML5Backend}>
                      <div
                        className="d-flex flex-wrap mr-0"
                        style={{
                          marginLeft: "-10px",
                          marginTop: "-30px",
                          position: "absolute",
                        }}
                      >
                        {activeButton === "Condition" &&
                          conditionOptions.map((option, index) => (
                            <DraggableOption
                              key={index}
                              label={option.label}
                              imageUrl={option.imageUrl}
                            />
                          ))}

                        {activeButton === "Action" &&
                          actionOptions.map((option, index) => (
                            <DraggableOption
                              key={index}
                              label={option.label}
                              imageUrl={option.imageUrl}
                            />
                          ))}
                        {activeButton === "Decision" &&
                          decisionOptions.map((option, index) => (
                            <DraggableOption
                              key={index}
                              label={option.label}
                              imageUrl={option.imageUrl}
                            />
                          ))}
                      </div>
                    </DndProvider>

                    <Modal
                      show={showCampaignModal}
                      onHide={() => setShowCampaignModal(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName("Change Campaigns")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Change Campaigns</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="Immediately"
                              id="immediately"
                              checked={executionType === "immediately"}
                              onChange={() =>
                                handleExecutionTypeChange("immediately")
                              }
                            />

                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDate">
                                  <Form.Label>
                                    <strong>Specify Date</strong>
                                  </Form.Label>
                                  <Form.Control
                                    type="date"
                                    value={specifiedDate}
                                    onChange={(e) =>
                                      setSpecifiedDate(e.target.value)
                                    }
                                  />
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>

                        <Form.Group controlId="formContactDetails">
                          <Form.Label>
                            <strong>Add contact to</strong>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter details"
                            value={addContactDetails}
                            onChange={(e) =>
                              handleAddContactChange(e.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId="formRemoveContactDetails">
                          <Form.Label>
                            <strong>Remove contact from</strong>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter details"
                            value={removeContactDetails}
                            onChange={(e) =>
                              handleRemoveContactChange(e.target.value)
                            }
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setShowCampaignModal(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={ValidEmailAddressVisible}
                      onHide={() => setValidEmailAddressVisible(false)}
                      style={{ maxHeight: "90vh" }}
                      onShow={() => setModalName2("Valid Email Address")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Valid Email Address</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formContactName">
                          {" "}
                          {/* Added Form.Group for Contact Name */}
                          <Form.Label>
                            <strong>Contact Name</strong>{" "}
                            {/* Contact Name label */}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter  name"
                            value={contactName}
                            onChange={(e) => setContactName(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      type="time"
                                      value={specifiedTime}
                                      onChange={(e) =>
                                        setSpecifiedTime(e.target.value)
                                      }
                                      step="3600"
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setValidEmailAddressVisible(false);
                              console.log("Contact Name:", contactName);
                              console.log("Execution Type:", executionType);
                              console.log("Specified Date:", specifiedDate);
                              console.log("Specified Time:", specifiedTime);
                              console.log("AM/PM:", amPm);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showAddDoNotContactModal}
                      onHide={() => setShowAddDoNotContactModal(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName3("Delay")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Delay</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {/* Delay Time Section */}
                        <div style={{ marginTop: "10px" }}>
                          <h5>Delay Time:</h5>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* Input Box for Time */}
                            <InputGroup style={{ marginRight: "10px" }}>
                              <FormControl
                                type="number"
                                placeholder="Enter time"
                                aria-label="Delay time"
                                aria-describedby="basic-addon2"
                                value={delayTime}
                                onChange={(e) =>
                                  handleDelayTimeChange(e.target.value)
                                }
                              />
                            </InputGroup>

                            {/* Dropdown for Unit Selection */}
                            <Form.Select
                              aria-label="Delay unit"
                              value={delayUnit}
                              onChange={(e) =>
                                handleDelayUnitChange(e.target.value)
                              }
                            >
                              <option>Seconds</option>
                              <option>Minutes</option>
                              <option>Hours</option>
                              <option>Days</option>
                            </Form.Select>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setShowAddDoNotContactModal(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={ContactDeviceVisible}
                      onHide={() => setContactDeviceVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName4("Contact Device")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contact Device</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      type="time"
                                      value={specifiedTime}
                                      onChange={(e) =>
                                        setSpecifiedTime(e.target.value)
                                      }
                                      step="3600"
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>

                        {/* Device Type */}
                        <Form.Group controlId="formDeviceType">
                          <Form.Label>
                            <strong>Device Type</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={deviceType}
                            onChange={(e) => setDeviceType(e.target.value)}
                          >
                            <option>Select a brand</option>
                            <option>Desktop</option>
                            <option>Smartphone</option>
                            <option>Tablet</option>
                            <option>TV</option>
                            <option>Camera</option>
                            <option>Smart Speaker</option>
                          </Form.Control>
                        </Form.Group>

                        {/* Device Brand */}
                        <Form.Group controlId="formDeviceBrand">
                          <Form.Label>
                            <strong>Device Brand</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={deviceBrand}
                            onChange={(e) => setDeviceBrand(e.target.value)}
                          >
                            <option>Select a brand</option>
                            <option>Apple</option>
                            <option>Samsung</option>
                            <option>Microsoft</option>
                            <option>Sony</option>
                            {/* Add more brands as needed */}
                          </Form.Control>
                        </Form.Group>

                        {/* Device OS */}
                        <Form.Group controlId="formDeviceOS">
                          <Form.Label>
                            <strong>Device OS</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={deviceOS}
                            onChange={(e) => setDeviceOS(e.target.value)}
                          >
                            <option>Android</option>
                            <option>Blackberry</option>
                            <option>iOS</option>
                            <option>Windows</option>
                            <option>Mac</option>
                          </Form.Control>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setContactDeviceVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={ContactFieldVisible}
                      onHide={() => setContactFieldVisible(false)}
                      style={{ maxHeight: "90vh" }}
                      onShow={() => setModalName5("Contact Field Value")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contact Field Value</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      type="time"
                                      value={specifiedTime}
                                      onChange={(e) =>
                                        setSpecifiedTime(e.target.value)
                                      }
                                      step="3600"
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>
                        <Form.Group controlId="formField">
                          <Form.Label>
                            <strong>Contact Field </strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={fieldValue}
                            onChange={(e) => setFieldValue(e.target.value)}
                          >
                            <option value="" disabled>
                              Choose One
                            </option>
                            {contactFieldOptions.map((field, index) => (
                              <option key={index} value={field}>
                                {field}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="formOperator">
                          <Form.Label>
                            <strong>Operator</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={operator}
                            onChange={(e) => setOperator(e.target.value)}
                          >
                            <option value="">Choose One</option>
                            <option value="equal">Equal</option>
                            <option value="notEqual">Not Equal</option>
                            <option value="greaterThan">Greater Than</option>
                            <option value="lessThan">Less Than</option>
                            <option value="like">Like</option>
                          </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="formValue">
                          <Form.Label>
                            <strong>Value</strong>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={contactformvalue}
                            onChange={(e) => {
                              setcontactformvalue(e.target.value);
                            }}
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              console.log("Contact Name:", contactName);
                              console.log("Execution Type:", executionType);
                              console.log("Specified Date:", specifiedDate);
                              console.log("Specified Time:", specifiedTime);
                              console.log("AM/PM:", amPm);
                              setContactFieldVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={ContactSegmentModalVisible}
                      onHide={() => setContactSegmentModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName6("Contact Segments")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contact Segments</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />

                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>
                        <Form.Group controlId="formName">
                          <Form.Label>
                            <strong>Segment</strong>
                          </Form.Label>

                          <div className="dropdown-box">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleDropdownChange(e.target.value)
                              }
                            >
                              <option value="" disabled selected>
                                Choose One
                              </option>
                              {savedDetails.map((option) => (
                                <option key={option.id} value={option.name}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setContactSegmentModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={FormFieldModalVisible}
                      onHide={() => setFormFieldModalVisible(false)}
                      style={{ maxHeight: "90vh" }}
                      onShow={() => setModalName7("Form Field Value")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Form Field Value</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      type="time"
                                      value={specifiedTime}
                                      onChange={(e) =>
                                        setSpecifiedTime(e.target.value)
                                      }
                                      step="3600"
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>

                        <Form.Group controlId="formUsername">
                          <Form.Label>
                            <strong>Choose a username</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={selectedUsername}
                            onChange={(e) =>
                              setSelectedUsername(e.target.value)
                            }
                          >
                            <option value="">Select a username</option>
                            {usernames.map((username, index) => (
                              <option key={index} value={username}>
                                {username}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="formOperator">
                          <Form.Label>
                            <strong>Operator</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={formoperator}
                            onChange={(e) => setformOperator(e.target.value)}
                          >
                            <option value="">Choose One</option>
                            <option value="equal">Equal</option>
                            <option value="notEqual">Not Equal</option>
                          </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="formValue">
                          <Form.Label>
                            <strong>Value</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={formvalue}
                            onChange={(e) => setformvalue(e.target.value)}
                          >
                            <option value="Date">Date</option>
                            <option value="Email">Email</option>
                            <option value="Text">Text</option>
                            <option value="Text area">Text area</option>
                            <option value="File">File</option>
                            <option value="Number">Number</option>
                            <option value="URL">URL</option>
                          </Form.Control>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setFormFieldModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={ContactSegmentModalVisible}
                      onHide={() => setContactSegmentModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName8("Contact Segments")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contact Segments</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDateTime">
                                  <Form.Label>
                                    <strong>Specify Date and Time</strong>
                                  </Form.Label>
                                  <div style={{ display: "flex" }}>
                                    <Form.Control
                                      type="date"
                                      value={specifiedDate}
                                      onChange={(e) =>
                                        setSpecifiedDate(e.target.value)
                                      }
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      type="time"
                                      value={specifiedTime}
                                      onChange={(e) =>
                                        setSpecifiedTime(e.target.value)
                                      }
                                      step="3600"
                                      style={{ flex: 1, marginRight: "10px" }}
                                    />
                                    <Form.Control
                                      as="select"
                                      value={amPm}
                                      onChange={(e) => setAmPm(e.target.value)}
                                      style={{ width: "80px" }}
                                    >
                                      <option value="AM">AM</option>
                                      <option value="PM">PM</option>
                                    </Form.Control>
                                  </div>
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>

                        <Form.Group controlId="formName">
                          <Form.Label>
                            <strong>Segment</strong>
                          </Form.Label>

                          <div className="dropdown-box">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={Selectedvalue}
                              onChange={(e) =>
                                handleDropdown2Change(e.target.value)
                              }
                            >
                              <option value="" disabled>
                                Choose One
                              </option>
                              {savedDetails.map((option) => (
                                <option key={option.id} value={option.name}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setContactSegmentModalVisible(false);
                              console.log("Contact Name:", contactName);
                              console.log("Execution Type:", executionType);
                              console.log("Specified Date:", specifiedDate);
                              console.log("Specified Time:", specifiedTime);
                              console.log("AM/PM:", amPm);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showDeleteContactModal}
                      onHide={() => setShowDeleteContactModal(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName9("Delete Contact")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Delete Contact</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="Immediately"
                              id="immediately"
                              checked={executionType === "immediately"}
                              onChange={() =>
                                handleExecutionTypeChange("immediately")
                              }
                            />
                            <Form.Check
                              type="radio"
                              label="At a specified date"
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDate">
                                  <Form.Label>
                                    <strong>Specify Date</strong>
                                  </Form.Label>
                                  <Form.Control
                                    type="date"
                                    value={specifiedDate}
                                    onChange={(e) =>
                                      setSpecifiedDate(e.target.value)
                                    }
                                  />
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setShowDeleteContactModal(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={showAdjustContactPointsModal}
                      onHide={() => setShowAdjustContactPointsModal(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName10("Adjust Contact Points")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Adjust Contact Points</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        <Form.Group controlId="formExecution">
                          <div>
                            <Form.Check
                              type="radio"
                              label="Immediately"
                              id="immediately"
                              checked={executionType === "immediately"}
                              onChange={() =>
                                handleExecutionTypeChange("immediately")
                              }
                            />

                            <Form.Check
                              type="radio"
                              label="At a specified date "
                              id="specifiedDate"
                              checked={executionType === "specifiedDate"}
                              onChange={() =>
                                handleExecutionTypeChange("specifiedDate")
                              }
                            />
                            {executionType === "specifiedDate" && (
                              <div>
                                <Form.Group controlId="formSpecifiedDate">
                                  <Form.Label>
                                    <strong>Specify Date</strong>
                                  </Form.Label>
                                  <Form.Control
                                    type="date"
                                    value={specifiedDate}
                                    onChange={(e) =>
                                      setSpecifiedDate(e.target.value)
                                    }
                                  />
                                </Form.Group>
                              </div>
                            )}
                          </div>
                        </Form.Group>

                        <Form.Group controlId="formPointsAdjustment">
                          <Form.Label>
                            <strong>Points (+/-)</strong>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter points adjustment"
                            value={pointsAdjustment}
                            onChange={(e) =>
                              handlePointsAdjustmentChange(e.target.value)
                            }
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setShowAdjustContactPointsModal(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={showEmailModal}
                      onHide={() => setShowEmailModal(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName11("Send Email")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Send Email</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div style={{ marginTop: "10px" }}>
                          <Form.Group controlId="formFile">
                            <Form.Label>
                              <strong>Choose File</strong>
                            </Form.Label>
                            <Form.Control
                              type="file"
                              onChange={handleFileChange}
                            />
                            {selectedFile && (
                              <p>Selected File: {selectedFile}</p>
                            )}
                          </Form.Group>

                          <Form.Group controlId="formSubject">
                            <Form.Label>
                              <strong>Subject</strong>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter subject"
                              value={subject}
                              onChange={(e) =>
                                handleSubjectChange(e.target.value)
                              }
                            />
                          </Form.Group>
                          <Form.Group controlId="formMessage">
                            <Form.Label>
                              <strong>Message</strong>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              placeholder="Enter message"
                              value={message}
                              onChange={(e) =>
                                handleMessageChange(e.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            onClick={() => {
                              handleCloseModal();
                              setShowEmailModal(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={downloadAssetModalVisible}
                      onHide={() => setDownloadAssetModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName12("Download asset")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Download asset</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {/* Asset selection form */}
                        <Form.Group controlId="formChannels">
                          <Form.Label>
                            <strong>Assets</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={selectedAsset}
                            onChange={(e) => {
                              setSelectedAsset(e.target.value);
                              console.log("Selected Asset:", e.target.value);
                            }}
                          >
                            <option value="" disabled defaultValue>
                              Choose one or more...
                            </option>
                            <option value="email">GRAPESJS</option>
                            {/* Add more options as needed */}
                          </Form.Control>
                        </Form.Group>
                      </Modal.Body>

                      {/* Button to trigger sendData */}
                      <Modal.Footer>
                        <Button
                          variant="primary"
                          style={{ marginRight: "-10px" }}
                          onClick={() => {
                            handleCloseModal();
                            setDownloadAssetModalVisible(false);
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={deviceVisitModalVisible}
                      onHide={() => setDeviceVisitModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName13("Device Visit")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Device Visit</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {/* Device Type */}
                        <Form.Group controlId="formDeviceType">
                          <Form.Label>
                            <strong>Device Type</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={devicevisitType}
                            onChange={(e) => setDevicevisitType(e.target.value)}
                          >
                            <option>Select a brand</option>
                            <option>Desktop</option>
                            <option>Smartphone</option>
                            <option>Tablet</option>
                            <option>TV</option>
                            <option>Camera</option>
                            <option>Smart Speaker</option>
                          </Form.Control>
                        </Form.Group>

                        {/* Device Brand */}
                        <Form.Group controlId="formDeviceBrand">
                          <Form.Label>
                            <strong>Device Brand</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={devicevisitBrand}
                            onChange={(e) =>
                              setDevicevisitBrand(e.target.value)
                            }
                          >
                            <option>Select a brand</option>
                            <option>Apple</option>
                            <option>Samsung</option>
                            <option>Microsoft</option>
                            <option>Sony</option>
                            {/* Add more brands as needed */}
                          </Form.Control>
                        </Form.Group>

                        {/* Device OS */}
                        <Form.Group controlId="formDeviceOS">
                          <Form.Label>
                            <strong>Device OS</strong>
                          </Form.Label>
                          <Form.Control
                            as="select"
                            style={{ marginBottom: "10px" }}
                            value={devicevisitOS}
                            onChange={(e) => setDevicevisitOS(e.target.value)}
                          >
                            <option>Android</option>
                            <option>Blackberry</option>
                            <option>iOS</option>
                            <option>Windows</option>
                            <option>Mac</option>
                          </Form.Control>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setDeviceVisitModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={RequestDynamicContentModalVisible}
                      onHide={() => setRequestDynamicContentModalVisible(false)}
                      style={{ maxHeight: "70vh" }}
                      onShow={() => setModalName14("Request Dynamic content")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Request Dynamic content</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        <Form.Group controlId="formName">
                          <Form.Label>
                            <strong>Dynamic Content</strong>
                          </Form.Label>

                          <div className="dropdown-box">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={dynamiccontentvalue}
                              onChange={(e) =>
                                handleDropdown3Change(e.target.value)
                              }
                            >
                              <option value="" disabled>
                                Choose One
                              </option>
                              {dynamiccontent.length > 0 ? (
                                dynamiccontent.map((internalName, index) => (
                                  <option key={index} value={internalName}>
                                    {internalName}
                                  </option>
                                ))
                              ) : (
                                <option value="" disabled>
                                  No dynamic content available
                                </option>
                              )}
                            </select>
                          </div>
                        </Form.Group>
                      </Modal.Body>

                      <Modal.Footer>
                        <div className="text-end">
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setRequestDynamicContentModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={submitFormModalVisible}
                      onHide={() => setSubmitFormModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName15("Submit form")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Submit form</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formName">
                          <Form.Label>
                            <strong>Dynamic Content</strong>
                          </Form.Label>

                          <div className="dropdown-box">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={campaignName}
                              onChange={(e) => setCampaignName(e.target.value)}
                            >
                              <option value="" disabled>
                                Choose One
                              </option>
                              {usernames.length > 0 ? (
                                usernames.map((username, index) => (
                                  <option key={index} value={username}>
                                    {username}
                                  </option>
                                ))
                              ) : (
                                <option value="" disabled>
                                  No usernames available
                                </option>
                              )}
                            </select>
                          </div>
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setSubmitFormModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={visitPageModalVisible}
                      onHide={() => setVisitPageModalVisible(false)}
                      style={{ maxHeight: "80vh" }}
                      onShow={() => setModalName16("Visit a Page")}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Visit a Page</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group controlId="formCampaignName">
                          <Form.Label>
                            <strong>URL</strong>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            style={{ marginBottom: "10px" }}
                            placeholder=""
                            value={url}
                            onChange={(e) => seturl(e.target.value)}
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <div
                          className="text-end"
                          style={{ display: "flex", marginTop: "-30px" }}
                        >
                          <Button
                            variant="primary"
                            style={{ marginRight: "-10px" }}
                            onClick={() => {
                              handleCloseModal();
                              setVisitPageModalVisible(false);
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchCampaignBuilder;
